import { Deferred } from './Deferred';
export class TimeoutException extends Error {
    constructor(message: string) {
        super(message);

        Object.setPrototypeOf(this, TimeoutException.prototype);
    }
}

export function timeout<T>(promise: Promise<T>, msOrTimeout?: number | Promise<never>): Promise<T> {
    const promises: Promise<any>[] = [];

    promises.push(promise);

    if (msOrTimeout == undefined) {
        // do nothing
    } else if (msOrTimeout instanceof Promise) {
        promises.push(msOrTimeout);
    } else if (!Number.isNaN(msOrTimeout)) {
        promises.push(delayReject(msOrTimeout));
    }

    return Promise.race(promises);
}

export function delay(ms: number) {
    return new Promise<undefined>((resolve, reject) => setTimeout(resolve, ms));
}

export function delayReject(ms: number) {
    return new Promise<never>((resolve, reject) =>
        setTimeout(() => reject(new TimeoutException(`Timed out in ${ms} ms.`)), ms)
    );
}

export class CancellationSource {
    constructor() {
        this.deferred = new Deferred<never>();
    }

    public get promise() {
        return this.deferred.promise;
    }

    public cancel() {
        this.deferred.reject(new TimeoutException('Cancelled'));
    }

    private deferred: Deferred<never>;
}
